const defaultMessagesMap = {
  noMatchingResults: "No matching results",
  action: {
    button: {
      preText: "Update your filters to search again.",
      text: "Search for nearby results"
    },
    link: {
      preText: "Update your filters to search again or",
      text: "search for nearby results."
    }
  }
};
const getMessages = (props) => {
  const defaultActionMessages = defaultMessagesMap.action[props.dsf_action_target] ?? defaultMessagesMap.action.link;
  return {
    noMatchingResults: props.dsf_no_matching_results_text ?? defaultMessagesMap.noMatchingResults,
    action: {
      preText: props.dsf_action_pre_text ?? defaultActionMessages.preText,
      text: props.dsf_action_text ?? defaultActionMessages.text
    }
  };
};
export {
  getMessages
};
